import { BookingStatusEnum } from "~/utils/enums/bookings-events.enums";

export const useBookings = () => {
  function statusMapping(value: string): { name: string; value: string; type: string } | undefined {
    return [
      {
        name: BookingStatusEnum.BOOKING_TO_BE_CONFIRMED,
        value: "À confirmer",
        type: "light_orange",
      },
      {
        name: BookingStatusEnum.BOOKING_CONFIRMED,
        value: "Inscrit",
        type: "light_green",
      },
      {
        name: BookingStatusEnum.BOOKING_TRAINING_STARTED,
        value: "Formation démarrée",
        type: "light_blue",
      },
      {
        name: BookingStatusEnum.BOOKING_TRAINING_ENDED,
        value: "Formation terminée",
        type: "green",
      },
      {
        name: BookingStatusEnum.BOOKING_ON_HOLD,
        value: "En attente",
        type: "grey",
      },
      {
        name: BookingStatusEnum.BOOKING_CANCELED,
        value: "Annulé",
        type: "light_red",
      },
      {
        name: BookingStatusEnum.BOOKING_REFUSED,
        value: "Refusé",
        type: "light_red",
      },
      {
        name: BookingStatusEnum.BOOKING_MISSING_PROOFS,
        value: "Justificatifs manquants",
        type: "light_orange",
      },
      {
        name: BookingStatusEnum.BOOKING_BILLABLE,
        value: "Facturable",
        type: "light_purple",
      },
      {
        name: BookingStatusEnum.BOOKING_INCOMPLETE,
        value: "Incomplet",
        type: "light_orange",
      },
      {
        name: BookingStatusEnum.BOOKING_NO_SHOW,
        value: "Absent",
        type: "light_grey",
      },
      {
        name: BookingStatusEnum.BOOKING_REMOVED,
        value: "Supprimé",
        type: "light_grey",
      },
    ].find((s) => s.name === value);
  }

  return {
    statusMapping,
  };
};
